export const selectBackgroundIcons = state => state.boards.background;
export const selectBoards = state => state.boards.boards;
export const selectIsLoading = state => state.boards.isLoading;
export const selectOneBoard = state => state.boards.oneBoard;
export const selectFilteredBoards = state => state.boards.filteredBoards;
export const selectStats = state => state.boards.stats;
export const selectAllCards = state => state.boards.allCards;
